const ArrowRound = () => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1088 9.91667C13.165 12.5869 10.6184 14.5 7.625 14.5C3.82804 14.5 0.75 11.422 0.75 7.625C0.75 3.82804 3.82804 0.75 7.625 0.75C9.97263 0.75 11.5417 1.75365 13.0592 3.46576M13.6842 0.958333V3.66667C13.6842 4.01184 13.4043 4.29167 13.0592 4.29167H10.3508"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowRound
